export default {
      id: "ic-misc-listen-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-listen-usage",
      toString: function () {
        return this.url;
      }
    }